import { AuthenticatedTemplate } from "@azure/msal-react";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import React from "react";
import CheckListIcon from '@mui/icons-material/Checklist';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import { useNavigate } from "react-router-dom";
import { useAppSelector } from '../../../../../app/hooks';
import { useGetMyProfileQuery } from '../../../../../services/ProfileService';
import { hasSchedulingAccess, hasPhysicianRequestsAccess } from '../../../../profile/utils/profileUtils';
import { PHYSICIAN_REQUESTS_QUEUE_PATH } from '../../../../physicianRequests';
import { BLOCK_SCHEDULE_PATH, SURGERY_BOARD_PATH } from '../../../../surgeryBoard';

function SchedulingMenu(){
    const navigate = useNavigate();
    const [open,setopen] = React.useState(false);
    const selectedCenter = useAppSelector(state => state.center.selectedCenter);
    const { data: profile } = useGetMyProfileQuery();
    const company = profile?.organization || '';
    const navigateWithContext = (path: string) => {
        const params = new URLSearchParams();
        if (company) params.append('company', company);
        if (selectedCenter) params.append('center', selectedCenter);
        navigate(`${path}?${params.toString()}`);
    };
    return<React.Fragment>
        <AuthenticatedTemplate>
            {(hasSchedulingAccess(profile) || hasPhysicianRequestsAccess(profile)) && (
                <List component='nav' sx={{border:'black solid 1px'}}>
                    <ListItemButton onClick={() => setopen(!open)}>
                        <ListItemText primary='Scheduling' />
                        {open ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        {hasSchedulingAccess(profile) && (
                        <ListItemButton sx={{marginTop:'0px'}} onClick={() => navigateWithContext('/schedule')}>
                            <ListItemIcon><CalendarMonthIcon sx={{color:'white'}}/></ListItemIcon> Schedule
                        </ListItemButton>
                        )}
                        {hasPhysicianRequestsAccess(profile) && (
                        <ListItemButton sx={{marginTop:'0px'}} data-testid="physician-requests-menu-button" onClick={() => navigate(PHYSICIAN_REQUESTS_QUEUE_PATH)}>
                            <ListItemIcon><MedicalInformationIcon sx={{color:'white'}}/></ListItemIcon> Physician Requests
                        </ListItemButton>
                        )}
                        {hasSchedulingAccess(profile) && (
                        <React.Fragment>
                        <ListItemButton sx={{marginTop:'0px'}} onClick={() => navigateWithContext('/PatientLookup')}>
                            <ListItemIcon><CheckListIcon sx={{color:'white'}}/></ListItemIcon> PatientLookup
                        </ListItemButton>
                        <ListItemButton sx={{marginTop:'0px'}} data-testid="surgery-board-menu-button" onClick={() => navigateWithContext(SURGERY_BOARD_PATH)}>
                            <ListItemIcon><ViewWeekIcon sx={{color:'white'}}/></ListItemIcon> Surgery Board
                        </ListItemButton>
                        <ListItemButton sx={{marginTop:'0px'}} data-testid="block-schedule-menu-button" onClick={() => navigateWithContext(BLOCK_SCHEDULE_PATH)}>
                            <ListItemIcon><EventRepeatIcon sx={{color:'white'}}/></ListItemIcon> Block Schedule
                        </ListItemButton>
                        </React.Fragment>
                        )}
                    </Collapse>
                </List>
            )}
        </AuthenticatedTemplate>
    </React.Fragment>
}
export{SchedulingMenu}